import React, {useState} from "react";
import CustomIcon from "../../../icons/common/custom-icon/custom-icon";
import {ItemIconSize} from "../../../icons/@const";
import Button from "../../../buttons/gd-button/gd-button-ui5-new";
import {IconSelectorProps} from "../icon-selector";

export default function UrlTab_Content(props: IconSelectorProps) {

    const getUrlFromIcon = (icon: string | undefined) => {
        if (icon && icon.startsWith('url:')) {
            return icon.substring(4);
        }
        return '';
    }

    const [url, setUrl] = useState<string>(() => getUrlFromIcon(props.icon));

    const onUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newUrl = e.target.value;
        setUrl(newUrl);
        // props.onChange?.(`url:${newUrl}`);
    }

    const save = (e: React.ChangeEvent<HTMLInputElement>) => {
        // const newUrl = e.target.value;
        // setUrl(newUrl);
        props.onChange?.(`url:${url}`);
    }

    const style : React.CSSProperties = {
        position: "absolute",
        left: 6,
        top: 6,
    }

    return (
        <div className="p-10">
            <div className="flex-column-left-center">
                <div className="gd-search size-36">
                    <input
                        type        = "text"
                        className   = "gd-input"
                        placeholder = "Enter icon URL"
                        value       = {url}
                        onChange    = {onUrlChange}
                        style       = {{flexGrow: 1, marginRight: '10px'}}
                    />
                    <div style={style}>
                        <CustomIcon icon={`url:${url}`} size={ItemIconSize.SIZE_24}/>
                    </div>
                </div>

                <div className="m-t-30 max-w-150">
                    <Button label="Save" onClick={save} />
                </div>
            </div>
        </div>
    );
}
